/* Carosello recensioni Trustpilot.
   Lo scorrimento e' nativo (overflow-x + scroll-snap nel CSS): qui
   dentro ci sono solo le frecce e il loro stato di fine corsa. */
(function () {
  function init(root) {
    if (root.dataset.czTpReady) return;
    root.dataset.czTpReady = '1';

    var track = root.querySelector('[data-cz-tp-track]');
    var prev = root.querySelector('[data-cz-tp-prev]');
    var next = root.querySelector('[data-cz-tp-next]');
    if (!track || !prev || !next) return;

    function step() {
      var card = track.querySelector('.cz-tp__card');
      return card ? card.getBoundingClientRect().width : 260;
    }

    function refresh() {
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', refresh, { passive: true });

    if (window.ResizeObserver) new ResizeObserver(refresh).observe(track);
    refresh();
  }

  function boot() {
    document.querySelectorAll('[data-cz-tp]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', boot);
  /* Il theme editor ricarica la sezione senza ricaricare la pagina. */
  document.addEventListener('shopify:section:load', boot);
  boot();
})();
